import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import ProductTabs from "../../../Componants/Common/product tabs/ProductTabs";
import config from "../../../Componants/Common/config";
import {
  Autocomplete,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CommonButton from "../../../Componants/Common/Button";
import InputFileUpload from "../../../Componants/Common/Bulk Upload/InputFileUpload";
import Template from "../../../Componants/Common/Bulk Upload/Template";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import deleteIcon from "../../../Assests/deleteIcon.svg";
import ExportToExcel from "../../../Componants/Common/ExportToExcel";
import {
  createSubCategory,
  fetchBrandList,
  fetchCategoryList,
  fetchSubCategoryDropdown,
  fetchSubCategoryList,
  updateSubCategory,
  updateSubCategoryStatus,
  exportSubCategory,
} from "../../../API Service/apiService";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../Componants/Loader/Loader";
import Paginate from "../../../Componants/Common/Paginate";

const cells = [
  "S.No",
  "Brand",
  "Category",
  "Sub Category",
  "Description",
  "Action",
];
const subcategoryheader = [
  { label: "Brand", key: "brandName" },
  { label: "Category", key: "categoryName" },
  { label: "Sub Category", key: "subcategoryName" },
  { label: "Description", key: "description" },
  { label: "Status", key: "active" },
];

const Manageproductsubcatgeory = () => {
  const [brandName, setBrandName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [subcategoryName, setSubcategoryName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [editIndex, setEditIndex] = useState(false);
  const pageSize = config.pageSize;
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSearchBrand, setSelectedSearchBrand] = useState(null);
  const [selectedSearchCategory, setSelectedSearchCategory] = useState(null);
  const [totalRecords, setTotalRecords] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [dataSize, setDataSize] = useState(pageSize);
  const [tableData, setTableData] = useState([]);
  const [brandList, setBrandList] = useState([]); // Renamed for clarity
  const [activeBrandList, setActiveBrandList] = useState([]);
  const [categoryListForCreate, setCategoryListForCreate] = useState([]);
  const [categoryListForSearch, setCategoryListForSearch] = useState([]);
  const [brandError, setBrandError] = useState(false);
  const [categoryError, setCategoryError] = useState(false);
  const [subcategoryError, setSubcategoryError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [subcategoryList, setSubcategoryList] = useState([]);
  // Search states (only on button click)
  const [searchInputBrand, setSearchInputBrand] = useState(""); // Temporary brand search input
  const [searchInputCategory, setSearchInputCategory] = useState(""); // Temporary category search input
  const [searchInputSubcategory, setSearchInputSubcategory] = useState(""); // Temporary subcategory search input
  const [searchParams, setSearchParams] = useState({
    brandId: "",
    categoryId: "",
    subcategoryName: "",
    page: 1,
    limit: 10,
  });

  const getBrandList = async () => {
    try {
      setLoading(true);
      const response = await fetchBrandList();
      setBrandList(response.data.brandList);
      const filteredActiveBrands = response.data.brandList.filter(
        (brand) => brand.active === true
      );
      setActiveBrandList(filteredActiveBrands);
    } catch (error) {
      console.error("Error fetching brand list:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubCategories = async () => {
    try {
      setLoading(true);
      let response;
      if (isSearching) {
        response = await fetchSubCategoryList(
          searchParams.subcategoryName,
          searchParams.page,
          searchParams.limit,
          searchParams.brandId,
          searchParams.categoryId
        );
      } else {
        response = await fetchSubCategoryList("", page, limit, "", ""); // Fetch all subcategories
      }
      console.log("Fetched SubCategories:", response);
      setTableData(response.data.subcategory || []);
      setTotalRecords(response.data.totalSubcategories);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
      toast.error("Failed to fetch subcategories");
    } finally {
      setLoading(false);
    }
  };

  const fetchCategoriesForCreate = async (brandId) => {
    try {
      setLoading(true);
      const response = await fetchCategoryList(brandId, "", 1, 100, "true");
      setCategoryListForCreate(response.data.categories || []);
    } catch (error) {
      console.error("Error fetching categories for brand:", error);
      toast.error("Failed to fetch categories for selected brand");
      setCategoryListForCreate([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategoriesForSearch = async (brandId) => {
    try {
      setLoading(true);
      const response = await fetchCategoryList(brandId, "", 1, 100, "true");
      setCategoryListForSearch(response.data.categories || []);
    } catch (error) {
      console.error("Error fetching categories for brand:", error);
      toast.error("Failed to fetch categories for selected brand");
      setCategoryListForSearch([]);
    } finally {
      setLoading(false);
    }
  };

  const truncateText = (text, maxLength) => {
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  const handleCancel = () => {
    setBrandName("");
    setCategoryName("");
    setSubcategoryName("");
    setDescription("");
    setSelectedBrand(null);
    setSelectedCategory(null);
    setEditIndex(false);
    setBrandError(false);
    setCategoryError(false);
    setSubcategoryError(false);
    setDescriptionError(false);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setSearchParams((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  const handleSave = async () => {
    let isValid = true;

    if (!selectedBrand || !selectedBrand._id) {
      setBrandError(true);
      isValid = false;
    } else {
      setBrandError(false);
    }

    if (!selectedCategory || !selectedCategory._id) {
      setCategoryError(true);
      isValid = false;
    } else {
      setCategoryError(false);
    }

    if (!subcategoryName.trim()) {
      setSubcategoryError(true);
      isValid = false;
    } else {
      setSubcategoryError(false);
    }

    if (!description.trim()) {
      setDescriptionError(true);
      isValid = false;
    } else {
      setDescriptionError(false);
    }

    if (!isValid) {
      return;
    }

    const requestData = {
      brandId: selectedBrand._id,
      categoryId: selectedCategory._id,
      subcategoryName: subcategoryName,
      description: description,
      active: true, // Set subcategory as active by default
    };

    try {
      setLoading(true);
      if (!editIndex) {
        const response = await createSubCategory(requestData);
        toast.success(response.message || "Sub-Category saved successfully!");
      } else {
        const dataToUpdate = {
          _id: editIndex,
          brandId: selectedBrand._id,
          categoryId: selectedCategory._id,
          subcategoryName: subcategoryName,
          description: description,
        };
        const response = await updateSubCategory(dataToUpdate);
        toast.success(response.message || "Sub-Category updated successfully!");
        setEditIndex(false);
      }
    } catch (error) {
      console.error(`Error saving/updating subcategory: ${error}`);
      toast.error("Failed to save/update subcategory");
    } finally {
      setLoading(false);
      if (!isSearching) {
        fetchSubCategories();
      } else {
        handleSearch();
      }
      handleCancel();
    }
  };

  const handleEdit = (
    _id,
    brandId,
    brandName,
    categoryId,
    categoryName,
    subcategoryName,
    description
  ) => {
    setEditIndex(_id);
    setSelectedBrand({ _id: brandId, brandName: brandName });
    setBrandName(brandName);
    setSelectedCategory({ _id: categoryId, categoryName: categoryName });
    setCategoryName(categoryName);
    setSubcategoryName(subcategoryName);
    setDescription(description);
    fetchCategoriesForCreate(brandId); // Fetch categories for the selected brand
  };

  const handleStatus = async (subcategoryId) => {
    try {
      setLoading(true);
      const response = await updateSubCategoryStatus({
        subcategoryId: subcategoryId,
      });
      if (response.status === "success") {
        toast.success("Status Updated Successfully");
      }
    } catch (error) {
      console.error(`Error updating status: ${error}`);
      toast.error(`Failed to update status`);
    } finally {
      setLoading(false);
      if (!isSearching) {
        fetchSubCategories();
      } else {
        handleSearch();
      }
    }
  };

  // Search functionality (only on button click)
  const handleSearch = async () => {
    try {
      setLoading(true);
      setIsSearching(true);
      setPage(1);

      const searchBody = {
        brandId: searchInputBrand || "",
        categoryId: searchInputCategory || "",
        subcategoryName: searchInputSubcategory || "",
        page: 1,
        limit: limit,
      };

      setSearchParams(searchBody);

      const response = await fetchSubCategoryList(
        searchBody.subcategoryName,
        searchBody.page,
        searchBody.limit,
        searchBody.brandId,
        searchBody.categoryId
      );

      if (response.data) {
        setTableData(response.data.subcategory || []);
        setTotalRecords(response.data.totalSubcategories);
      }
    } catch (error) {
      console.error("Error in search:", error);
      toast.error("Failed to search subcategories");
    } finally {
      setLoading(false);
    }
  };

  const handleSearchCancel = async () => {
    setSearchInputBrand("");
    setSearchInputCategory("");
    setSearchInputSubcategory("");
    setSelectedSearchBrand(null);
    setSelectedSearchCategory(null);
    setSearchParams({
      brandId: "",
      categoryId: "",
      subcategoryName: "",
      page: 1,
      limit: 10,
    });
    setIsSearching(false);
    await fetchSubCategories();
  };

  const handleBrandSelection = async (event, newValue) => {
    setSelectedBrand(newValue || null);
    setBrandName(newValue?.brandName || "");
    setBrandError(false);

    if (newValue?._id) {
      await fetchCategoriesForCreate(newValue._id);
    } else {
      setCategoryListForCreate([]);
    }
    setSelectedCategory(null);
  };

  const handleCategorySelection = (event, newValue) => {
    setSelectedCategory(newValue || null);
    setCategoryName(newValue?.categoryName || "");
    setCategoryError(false);
  };

  const handleSearchBrandSelection = async (event, newValue) => {
    const brandId = newValue?._id || "";
    setSelectedSearchBrand(newValue);
    setSearchInputBrand(brandId);
    setSearchInputCategory(""); // Reset category selection
    setSearchParams((prev) => ({
      ...prev,
      brandId: brandId,
      categoryId: "", // Reset category ID in search params
    }));

    // Fetch categories if brand is selected
    if (brandId) {
      await fetchCategoriesForSearch(brandId);
    } else {
      setCategoryListForSearch([]); // Clear categories if no brand selected
    }
    setSelectedSearchCategory(null);
  };

  const handleSearchCategorySelection = (event, newValue) => {
    const categoryId = newValue?._id || "";
    setSelectedSearchCategory(newValue);
    setSearchInputCategory(categoryId);
    setSearchParams((prev) => ({
      ...prev,
      categoryId: categoryId,
    }));
    if (categoryId) {
      subcategoryDropdown(categoryId);
    }
  };

  const subcategoryDropdown = async (categoryID) => {
    try {
      setLoading(true);
      const params = {
        categoryId: categoryID,
      };
      const response = await fetchSubCategoryDropdown(params);
      setSubcategoryList(response.data.subcategories || []);
    } catch (error) {
      console.error("Error fetching subcategory dropdown:", error);
      toast.error("Failed to fetch subcategory dropdown");
      setSubcategoryList([]);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      setLoading(true);
      const params = {
        brandId: searchParams.brandId,
        categoryId: searchParams.categoryId,
        subcategoryName: searchParams.subcategoryName
      };
      const response = await exportSubCategory(params);
      
      if (!response) {
        throw new Error('No data received from server');
      }

      const blob = new Blob([response], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = response.name || `subcategories.xlsx`;
      document.body.appendChild(a);
      a.click();
      
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);

      toast.success('Export completed successfully');
    } catch (error) {
      console.error('Error in export subcategory:', error);
      toast.error(error.message || 'Failed to export subcategories');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBrandList();
    fetchSubCategories();
  }, [page, isSearching]);

  return (
    <Grid container>
      {loading && <Loader />}
      <Toaster position="top-center" reverseOrder={false} />
      <HeaderNavigation value={"Product > Sub Category"} location={"/setting"} />
      {/* Create SubCategory */}
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid item container>
          <ProductTabs selectedTab="three" />
        </Grid>

        <Grid container spacing={10}>
          <Grid item>
            <Autocomplete
              id="brand-autocomplete"
              options={activeBrandList}
              getOptionLabel={(option) => option.brandName || ""}
              value={selectedBrand || null}
              onChange={handleBrandSelection}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Brand"
                  variant="standard"
                  style={{ width: "10rem" }}
                  error={brandError}
                  helperText={brandError ? "Brand is required." : ""}
                  required
                />
              )}
            />
          </Grid>

          <Grid item>
            <Autocomplete
              options={categoryListForCreate}
              getOptionLabel={(option) => option.categoryName || ""}
              value={selectedCategory || null}
              onChange={handleCategorySelection}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Category"
                  variant="standard"
                  style={{ width: "10rem" }}
                  error={categoryError}
                  helperText={categoryError ? "Category is required." : ""}
                  required
                />
              )}
            />
          </Grid>

          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="sub-category"
              label="Sub-Category"
              variant="standard"
              value={subcategoryName}
              onChange={(e) => {
                setSubcategoryName(e.target.value);
                setSubcategoryError(false); // Clear error on typing
              }}
              error={subcategoryError}
              helperText={subcategoryError ? "Sub-Category is required." : ""}
              required
            />
          </Grid>

          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="description"
              label="Description"
              variant="standard"
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                setDescriptionError(false); // Clear error on typing
              }}
              error={descriptionError}
              helperText={descriptionError ? "Description is required." : ""}
              required
            />
          </Grid>
        </Grid>
        <Grid container gap={2} spacing={5} sx={{ marginTop: "1rem" }}>
          <Grid item>
            <CommonButton
              name={editIndex === false ? "Save" : "Update"}
              handleOnClick={handleSave}
            />
          </Grid>
          <Grid item>
            <CommonButton name={"Cancel"} handleOnClick={handleCancel} />
          </Grid>
        </Grid>
      </Grid>

      {/* Bulk Upload */}
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid container>
          <Typography variant="h6">Bulk Upload</Typography>
        </Grid>
        <Grid container gap={10}>
          <Grid item>
            <InputFileUpload />
          </Grid>
          <Grid item>
            <CommonButton name={"Upload"} />
          </Grid>
          <Grid item sx={{ padding: "1rem" }}>
            <Template label={"Download Template"} />
          </Grid>
          <Grid item sx={{ padding: "1rem" }}>
            <Template label={"Download Reference Code"} />
          </Grid>
        </Grid>
      </Grid>

      {/* SubCategory List */}
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid item container>
          <Typography variant="h6">List View</Typography>
        </Grid>
        <Grid container gap={5}>
          <Grid item sx={{ minWidth: "200px" }}>
            <Autocomplete
              id="disable-close-on-select-brand"
              options={brandList}
              getOptionLabel={(option) => option.brandName || ""}
              value={selectedSearchBrand}
              onChange={handleSearchBrandSelection}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Brand"
                  variant="standard"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item sx={{ minWidth: "200px" }}>
            <Autocomplete
              id="disable-close-on-select-category"
              options={categoryListForSearch}
              getOptionLabel={(option) => option.categoryName || ""}
              value={selectedSearchCategory}
              onChange={handleSearchCategorySelection}
              disabled={!searchInputBrand}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Category"
                  variant="standard"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item sx={{ minWidth: "200px" }}>
            <Autocomplete
              id="disable-close-on-select-subcategory"
              options={subcategoryList}
              getOptionLabel={(option) => option.subcategoryName || ""}
              value={
                subcategoryList.find(
                  (subcategory) => subcategory.subcategoryName === searchInputSubcategory
                ) || null
              }
              onChange={(event, newValue) => {
                const subcategoryId = newValue?.subcategoryName || "";
                setSearchInputSubcategory(subcategoryId);
                setSearchParams((prev) => ({
                  ...prev,
                  subcategoryName: subcategoryId,
                }));
              }}
              disabled={!searchInputCategory} // Disable if no category selected
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sub Category"
                  variant="standard"
                  fullWidth
                />
              )}
            />
          </Grid>

          <Grid item>
            <CommonButton name={"Search"} handleOnClick={handleSearch} />
          </Grid>
          <Grid item>
            <CommonButton name={"Cancel"} handleOnClick={handleSearchCancel} />
          </Grid>
        </Grid>

        <Grid container>
          <Grid container justifyContent="flex-end">
            <ExportToExcel
             onClick={handleExport}
            />
          </Grid>

          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  {cells.map((cell, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        color: "white",
                        textAlign:
                          index === cells.length - 1 ? "right" : "center",
                        paddingRight: index === cells.length - 1 ? "4rem" : "",
                      }}
                    >
                      {cell}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={cells.length} align="center">
                      No Data Available
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        {(page - 1) * dataSize + index + 1}
                      </TableCell>
                      <TableCell align="center">
                        {truncateText(row.brandName, 50)}
                      </TableCell>
                      <TableCell align="center">
                        {truncateText(row.categoryName, 50)}
                      </TableCell>
                      <TableCell align="center">
                        {truncateText(row.subcategoryName, 50)}
                      </TableCell>
                      <TableCell align="center">
                        {truncateText(row.description, 50)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                        }}
                      >
                        <IconButton
                          onClick={() => handleStatus(row._id)}
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={
                              row.active === false ? inactiveIcon : activeIcon
                            }
                            alt="active"
                            height="20px"
                            width="20px"
                          />
                        </IconButton>

                        <IconButton
                          onClick={() =>
                            handleEdit(
                              row._id,
                              row.brandId,
                              row.brandName,
                              row.categoryId,
                              row.categoryName,
                              row.subcategoryName,
                              row.description
                            )
                          }
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={editIcon}
                            alt="Edit"
                            height="20px"
                            width="20px"
                          />
                        </IconButton>
                        {/* Uncomment and implement delete functionality if needed */}
                        {/* <IconButton
                          onClick={() => handleDelete(index, row._id)}
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={deleteIcon}
                            alt="Delete"
                            height="20px"
                            width="20px"
                          />
                        </IconButton> */}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <div
          className="pagination-container"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            dataSize={dataSize}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default Manageproductsubcatgeory;
